import { render, staticRenderFns } from "./TableStatusNoteBook.vue?vue&type=template&id=24779132&scoped=true&"
import script from "./TableStatusNoteBook.vue?vue&type=script&lang=js&"
export * from "./TableStatusNoteBook.vue?vue&type=script&lang=js&"
import style0 from "./TableStatusNoteBook.vue?vue&type=style&index=0&id=24779132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24779132",
  null
  
)

export default component.exports